import BaseModule from '../../../javascripts/helpers/baseModule';

export default class Input extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    this.input = element.querySelector('input');
    this.toggle = element.querySelector('button');
    this.icon = this.toggle.querySelector('use');
    this.title = this.toggle.querySelector('title');

    this.toggled = false;

    this.showLabel = element.getAttribute('data-show') || 'Show password';
    this.hideLabel = element.getAttribute('data-hide') || 'Hide password';

    this.initEventListeners();
  }

  togglePassword(e) {
    e.preventDefault();
    this.toggled = !this.toggled;

    this.icon.setAttribute('xlink:href', this.toggled ? '#eye-off' : '#eye');
    this.input.type = this.toggled ? 'text' : 'password';
    this.title.innerHTML = this.toggled ? this.hideLabel : this.showLabel;
    this.toggle.title = this.toggled ? this.hideLabel : this.showLabel;
  }

  initEventListeners() {
    this.toggle.addEventListener('click', (e) => this.togglePassword(e));
  }
}
